import React, { PropTypes } from "react";
import DocumentTitle from "react-document-title";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { intlShape } from "react-intl";
import { Scrollbars } from "react-custom-scrollbars";

import Header from "./Header";
import LeftMenu from "./LeftMenu";

import { FOLLOW_UPS } from "../../utils/data/models";
import * as intlActions from "../intl/intlActions";
import * as loginActions from "../login/loginActions";
import * as dataActions from "../../utils/data/dataActions";
import * as enumActions from "../../utils/enums/enumActions";

import Render from "../common/Render";
import { AGENT } from "../../utils/Roles";
import userHasAccess from "../../utils/userHasAccess";

import { getEnvironmentProperties } from "../common/environmentProperties";

class Dashboard extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      loggingOut: false,
    };

    this.scrollTop = this.scrollTop.bind(this);
  }

  getChildContext() {
    return {
      scrollTop: this.scrollTop,
    };
  }

  componentWillMount() {
    if (!this.props.auth.user) {
      this.props.loginActions.verifyAuth().then((data) => {
        this.props.intlActions.setLocale(
          data.payload.data.user.languageCode || "en-CA"
        );
      });
    } else {
      this.props.dataActions.clearDataCount(FOLLOW_UPS);

      if (userHasAccess(AGENT)) {
        const userId = this.props.auth.user.userId;
        this.props.dataActions.getDataCount(
          FOLLOW_UPS,
          [FOLLOW_UPS.archiveFilter, `followUps.recipientUserId==${userId}`],
          "FOLLOW_UPS"
        );
      }
    }
  }

  componentDidUpdate() {
    if (
      !!this.props.auth.accessToken && //If a token exists
      !this.props.auth.isVerifying && //We are not currently verifying auth status
      !this.props.auth.lastAuth
    ) {
      this.props.loginActions.verifyAuth();
    } else if (this.props.auth.user && userHasAccess(AGENT)) {
      const userId = this.props.auth.user.userId;
      this.props.dataActions.getDataCount(
        FOLLOW_UPS,
        [FOLLOW_UPS.archiveFilter, `followUps.recipientUserId==${userId}`],
        "FOLLOW_UPS"
      );
    }

    if (!this.props.auth.accessToken && this.props.auth.lastAuth) {
      //No auth token exists and we have verified with the server
      this.context.router.push({
        pathname: "/login",
        query: { timeout: true },
      });
    }
  }

  scrollTop() {
    const { scrollbars } = this.refs;
    scrollbars.scrollTop(0);
  }

  render() {
    const { displayEnvironmentOnScreen } = getEnvironmentProperties();
    const nonProdBannerClass = displayEnvironmentOnScreen ? "banner-offset" : "";

    return (
      <DocumentTitle
        title={this.context.intl.formatMessage({ id: "app.title" })}
      >
        {!this.state.loggingOut && (
          <div className={`page-container dashboard ${nonProdBannerClass}`}>
            <Render for={AGENT}>
              <LeftMenu followUpsCount={this.props.followUpsCount} />
            </Render>
            <div className="dashboard-content">
              {!!this.props.auth.user && <Header />}
              <div className="scrolling-content">
                <Scrollbars ref="scrollbars" autoHide={true}>
                  {!!this.props.auth.user && this.props.children}
                </Scrollbars>
              </div>
            </div>
          </div>
        )}
      </DocumentTitle>
    );
  }
}

Dashboard.propTypes = {
  auth: PropTypes.object.isRequired,
  children: PropTypes.node,
  dataActions: PropTypes.object.isRequired,
  enumActions: PropTypes.object.isRequired,
  followUpsCount: PropTypes.number,
  intlActions: PropTypes.object.isRequired,
  loginActions: PropTypes.object.isRequired,
};

Dashboard.contextTypes = {
  intl: intlShape,
  router: React.PropTypes.object,
};

Dashboard.childContextTypes = {
  scrollTop: PropTypes.func,
};

function mapStateToProps(state) {
  const followUps = state.data.followUpsCount || {};
  return {
    auth: state.auth,
    followUpsCount: followUps.count || 0,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    intlActions: bindActionCreators(intlActions, dispatch),
    loginActions: bindActionCreators(loginActions, dispatch),
    dataActions: bindActionCreators(dataActions, dispatch),
    enumActions: bindActionCreators(enumActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js